import { render } from "./dropdown-label-stay.vue?vue&type=template&id=e995f5b4"
const script = {}

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__